import clsx from 'clsx';

import styles from './ContextKindKeyBadge.module.css';

type ContextKindWithKey = {
  key: string;
};

export const ContextKindKeyBadge = ({
  className = '',
  contextKind,
}: {
  className?: string;
  contextKind: ContextKindWithKey;
}) => <code className={clsx(className, styles.contextKindKeyBadge)}>{contextKind.key}</code>;
